import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { EditAllowedIpData } from '../models/edit-allowed-ip-data';

@Component({
   changeDetection: ChangeDetectionStrategy.OnPush,
   selector: 'ndt-edit-allowed-ip-view',
   styleUrls: ['./edit-allowed-ip-view.component.scss'],
   templateUrl: './edit-allowed-ip-view.component.html',
   standalone: false,
})
export class EditAllowedIpViewComponent {
   @Input() callState: CallState;

   @Input() selectedAccount: { accountId: number; name: string } | null;
   @Input() selectedAccountId: number | null;

   @Input() form: UntypedFormGroup;

   @Output() formSubmitted = new EventEmitter<EditAllowedIpData>();

   @Output() formCanceled = new EventEmitter<void>();

   onCloseClick(): void {
      this.formCanceled.emit();
   }
   onCreate(): void {
      if (this.form.valid) {
         this.formSubmitted.emit();
      }
   }
   onSave(): void {
      if (this.form.valid) {
         this.formSubmitted.emit();
      }
   }
}
